module.exports = __webpack_public_path__ + "401e73bd.png";